import { IPlan } from "@/app/common/types";
import httpManager from "@/app/shared/utils/httpManager";

class PlansService {
  baseUrl = "/customers/";

  async fetchPlans(): Promise<IPlan[]> {
    const url = `/padmin/customers/plans/`;
    const response: any = await httpManager.get(url, { isPublic: true });
    
    return response.data;
  }
}

export const plansService = new PlansService();
